import { ofDelay } from '@c-cdk/common';
import { TaxService } from '../services/tax.service';
import { TAX_MOCK_LIST } from './tax-mock';

export class TaxMockService extends TaxService {
  override list() // ...params: Parameters<TaxService['list']>
  : ReturnType<TaxService['list']> {
    return ofDelay(TAX_MOCK_LIST);
  }
}
